module.exports = __webpack_public_path__ + "static/projects-c1102a3b3d2348de031a29127b377846.png";